import $ from 'jquery';
import 'intl-tel-input';
import 'intl-tel-input/build/js/utils.js';
import 'cleave.js';
import 'select2/dist/js/select2.full';
import 'intl-tel-input/build/css/intlTelInput.min.css';

import '@cm/styles/devise.scss';
import '@cm/styles/devise-signup.scss';

$(() => {
  const $form = $('.form--js-submit form');
  const $button = $form.find('.btn');

  // Prevent double click in signup forms
  function disableButtonAndSendForm(event) {
    event.preventDefault();
    $button.off('click', disableButtonAndSendForm);

    $button.addClass('disabled').attr('disabled', 'disabled');
    $form.submit();
  }

  if ($form) {
    $button.on('click', disableButtonAndSendForm);
  }
});
